import { FC, PropsWithChildren, Suspense } from 'react';

import Loader from 'components/Loader.tsx';

// eslint-disable-next-line react/display-name
const Lazy = (Component: FC<PropsWithChildren>) => (props: PropsWithChildren) => (
  <Suspense fallback={<Loader />}>
    <Component {...props} />
  </Suspense>
);

export default Lazy;
